var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.visibleWidgets.length)?_c('div',{staticClass:"widget-host"},_vm._l((_vm.visibleWidgets),function(w){return _c(_vm.templateFor(w.type),{key:w.id,tag:"component",attrs:{"widget":w},on:{"dismiss":function($event){_vm.dismiss(w.id, _vm.scopeOf(w))}}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }